import { ContactFlag } from './ContactDataManagementTypes';
import type { PhoneNumber } from './ContactTypes';
import { isContactInvalid, isContactMain, isContactUndefined } from './ContactService';
import type { NewStructureContact, PhoneNew } from './ContactAdapterTypes';
import { isNewPhone } from './ContactAdapterService';
import { selectContacts } from './useContacts';

const MOBILE_FLAG_LEGACY = 'mobile';

const transformPhoneContactToPhoneNumber = ({ id, flags, phone }: PhoneNew): PhoneNumber => ({
    id,
    number: phone?.number ?? '',
    isMainContact: isContactMain(flags),
    isInvalid: isContactInvalid(flags),
    isUndefined: isContactUndefined(flags),
    isMobileNumber: isMobileNumber(flags),
});

export function isMobileNumber(flags: string[] = []): boolean {
    return flags.includes(ContactFlag.MOBILE_PHONE_NUMBER) || flags.includes(MOBILE_FLAG_LEGACY);
}

export function getPhoneNumbers(): PhoneNumber[] {
    return getPhoneNumbersFromContacts(selectContacts());
}

export function getPhoneNumbersFromContacts(contacts: NewStructureContact[]): PhoneNumber[] {
    return contacts.filter(isNewPhone).map(transformPhoneContactToPhoneNumber);
}

export const transformNewStructurePhoneToPhoneNumber = (phone: PhoneNew): PhoneNumber =>
    transformPhoneContactToPhoneNumber(phone);
